// TODO remove redundant
export enum ApplicationThemeScope {
	APPLICATION = 'APPLICATION',
	DASHBOARD_CONTAINER = 'DASHBOARD_CONTAINER',
	CHART_DEMO = 'CHART_DEMO',
	DOC_EXPLORER = 'DOC_EXPLORER'
}


